import CarouselSliderPerspectivas from "./CarouselSliderPerspectivas";

export default CarouselSliderPerspectivas;
